import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import de from './locales/de.json';
import es from './locales/es.json';

const resources = {
	en: {
		translation: en
	},
	de: {
		translation: de
	},
	es: {
		translation: es
	},
};

i18n
	.use(initReactI18next)
	.init({
		resources,
		lng: 'en', // default language
		fallbackLng: 'en',
		interpolation: {
			escapeValue: false, // react already safes from xss
		},
	});

export default i18n;
